<template>
    <div class="dashboard-overview">
        <main class="dashboard-overview__container" v-if="hasReady">
            <header class="dashboard-overview__header">
                <span class="dashboard-overview__header-icon"><fa icon="fa-chart-line" /></span>
                <div>
                    <h1 class="dashboard-overview__title">Visão Geral</h1>
                </div>
            </header>

            <section class="dashboard-overview__top-grid">
                <article class="dashboard-overview__card">
                    <div class="dashboard-overview__card-head">
                        <span class="dashboard-overview__card-icon"><fa icon="fa-users" /></span>
                        <div>
                            <h2 class="dashboard-overview__card-title">Assinantes</h2>
                            <p class="dashboard-overview__card-subtitle">Total de assinantes ativos</p>
                        </div>
                    </div>
                    <div class="dashboard-overview__metric-value">{{ subscribers }}</div>
                    <div class="dashboard-overview__metric-helper">Total de assinantes</div>
                </article>

                <article class="dashboard-overview__card">
                    <div class="dashboard-overview__card-head">
                        <span class="dashboard-overview__card-icon"><fa icon="fa-database" /></span>
                        <div>
                            <h2 class="dashboard-overview__card-title">Armazenamento</h2>
                            <p class="dashboard-overview__card-subtitle">Espaço utilizado da sua conta</p>
                        </div>
                    </div>
                    <div class="dashboard-overview__storage-row">
                        <div class="dashboard-overview__storage-value">{{ returnStorage }}%</div>
                        <div class="dashboard-overview__storage-label">Utilizado</div>
                    </div>
                    <div class="dashboard-overview__progress">
                        <div
                            class="dashboard-overview__progress-bar"
                            :style="{ width: Math.min(100, Math.max(0, Number(returnStorage) || 0)) + '%' }"
                        ></div>
                    </div>
                    <div class="dashboard-overview__storage-footer">
                        {{ videoTimeUsed }}/{{ videoTimeTotal }} horas restantes
                    </div>
                </article>

                <article class="dashboard-overview__card">
                    <div class="dashboard-overview__card-head">
                        <span class="dashboard-overview__card-icon"><fa icon="fa-bolt" /></span>
                        <div>
                            <h2 class="dashboard-overview__card-title">Acesso Rápido</h2>
                            <p class="dashboard-overview__card-subtitle">Ações mais utilizadas</p>
                        </div>
                    </div>
                    <div class="dashboard-overview__quick-actions">
                        <button class="dashboard-overview__quick-action" type="button" @click="$router.push('/admin/nova-colecao')">
                            <fa icon="fa-clapperboard" />
                            <span>Nova coleção</span>
                            <fa icon="fa-chevron-right" />
                        </button>
                        <button class="dashboard-overview__quick-action" type="button" @click="$router.push('/admin/novo-usuario')">
                            <fa icon="fa-user-plus" />
                            <span>Adicionar Usuário</span>
                            <fa icon="fa-chevron-right" />
                        </button>
                    </div>
                </article>
            </section>

            <section class="dashboard-overview__bottom-grid">
                <article class="dashboard-overview__card dashboard-overview__chart-card">
                    <div class="dashboard-overview__card-head">
                        <span class="dashboard-overview__card-icon"><fa icon="fa-chart-column" /></span>
                        <div>
                            <h2 class="dashboard-overview__card-title">Visualizações</h2>
                            <p class="dashboard-overview__card-subtitle">Últimos 30 dias</p>
                        </div>
                    </div>
                    <div class="dashboard-overview__chart-wrap">
                        <Chart :data="dataViewVideos" />
                    </div>
                </article>

                <article class="dashboard-overview__card dashboard-overview__videos-card">
                    <div class="dashboard-overview__card-head">
                        <span class="dashboard-overview__card-icon"><fa icon="fa-circle-play" /></span>
                        <div>
                            <h2 class="dashboard-overview__card-title">Principais vídeos</h2>
                            <p class="dashboard-overview__card-subtitle">Mais visualizados nos últimos 30 dias</p>
                        </div>
                    </div>

                    <div class="dashboard-overview__videos-table" v-if="mostViewVideos && mostViewVideos.length">
                        <div class="dashboard-overview__videos-head">
                            <span>#</span>
                            <span>Conteúdo</span>
                            <span>Visualizações</span>
                        </div>
                        <div class="dashboard-overview__videos-row" v-for="(video, index) in mostViewVideos" :key="video.id">
                            <span class="dashboard-overview__video-rank">{{ index + 1 }}</span>
                            <div class="dashboard-overview__video-content">
                                <img
                                    v-if="video.finalVideoThumbnail"
                                    class="dashboard-overview__video-thumb"
                                    :src="video.finalVideoThumbnail"
                                    alt=""
                                />
                                <span class="dashboard-overview__video-title">{{ video.title }}</span>
                            </div>
                            <span class="dashboard-overview__video-views">{{ video.times }}</span>
                        </div>
                    </div>
                    <div class="dashboard-overview__empty-state" v-else>
                        <strong>Nenhum vídeo com visualizações no período.</strong>
                        <p>Quando houver acessos, os principais conteúdos aparecerão aqui.</p>
                    </div>
                </article>
            </section>
        </main>
        <Loader :hasReady="hasReady" />
    </div>
</template>

<script>
import Chart from '@/components/Weflix/Chart.vue'
import Dashboard from '@/utils/Weflix/dashboar'
import { mapState, mapActions } from 'vuex'
import Loader from '@/components/Weflix/Loader.vue'
export default {
    data() {
        return {
            subscribers: 0,
            storage: 0,
            videoTimeTotal: 0,
            videoTimeUsed: 0,
            hasReady: false,
            dataViewVideos: [],
            mostViewVideos: [],
            returnStorage: 0,
        }
    },
    computed:{
        ...mapState(['token'])
    },
    watch: {
        storage(newValue) {
            this.returnStorage = Math.round(newValue);
        }
    },
    components: {
        Chart,
        Loader
    },
    methods:{
        ...mapActions(['storePanelData']),
        async getDataDashboard(){
            try {
                const response = await Dashboard.getDataDashboard(this.token);
                this.storePanelData({panelData: response});
                this.subscribers = response.totalSubscriber;
                this.storage = response.percentage;
                this.videoTimeTotal = response.videoTimeTotal;
                this.videoTimeUsed = response.videoTimeUsed;
                this.dataViewVideos = response.progressDataMap;
                this.mostViewVideos = response.topVideos;
                this.hasReady = true;
            } catch (error) {
                console.error('Erro ao obter dados do painel:', error);
            }
        }
    },
    created(){
        this.getDataDashboard();
    }
}
</script>

<style>
@import url('@/css/weflix/dashboard-overview.css');
</style>
